import React, { useMemo } from 'react';

import { FONDO_CONO_ID, TELLO_ID } from '../../../hooks/useSampleProducts';

const SampleImage = ({ sampleCodiceArticolo, configid, className }) => {
  const handleOnError = ({ currentTarget }) => {
    currentTarget.onerror = null; // prevents looping
    currentTarget.src = '/images/artic_06.jpg';
  };

  const imageSrc = useMemo(() => {
    if (sampleCodiceArticolo === TELLO_ID) {
      return '/images/samples/TELO.jpg';
    } else if (sampleCodiceArticolo === FONDO_CONO_ID) {
      return '/images/samples/FONDO_CONO.jpg';
    } else {
      return `/admin/images/samples/families/${configid}.png`;
    } 
  }, [configid, sampleCodiceArticolo]);

  return <img className={className} src={imageSrc} onError={handleOnError} alt="" />;
};

export default SampleImage;